export enum Route {
  LandingPage = "",
  Main = "main",
  HomePage = "",
  RuleSliderPage = "",
  SetStorePage = "set-store",
  RulePage = "rule",
  MyBulgari = "my-bulgari",
  NewIn = "new-in",
  ErrorPage = "error-page",
  PrivacyPolicy = "privacy-policy",
  TermsAndConditions = "terms-and-conditions",
  Search = "search",
  Product = "product",
  PdfPage = "pdf",
  AddOn = "add-on"
}

export enum UrlParams {
  Rule = "ruleId",
  Category = "categoryId",
  SapCode = "sapCode"
}
